import { Fragment, useState } from "react";
import PrivateRouteList from "../../routes/PrivateRouteList";
import { Layout as Layouts } from "antd";
import Sidebar from "./Sidebar";
import packageJson from "../../../package.json";

const { Content, Footer } = Layouts;

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [broken, setBroken] = useState(false);
  return (
    <Fragment>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        broken={broken}
        setBroken={setBroken}
      >
        <MainLayout>
          <PrivateRouteList />
        </MainLayout>
      </Sidebar>
    </Fragment>
  );
};

const MainLayout = ({ children }) => {
  return (
    <Fragment>
      <Content className="site_content dashboard_content">{children}</Content>
      <Footer style={{ textAlign: "center" }}>
        <span>©2020 PTT Public Company Limited</span>
        <p>Website Version {packageJson.version}</p>
      </Footer>
    </Fragment>
  );
};

export default Layout;
